export const visit = (vm, at) => {
at({ "de": { "featureTables": { "compare": { "screenReader": { "featureAvailable": "Funktion verf\xFCgbar", "featureUnavailable": "Funktion nicht verf\xFCgbar" } } } } });
};